import { Box, Container, Typography } from '@mui/material';
import FadeIn from '../../../../../../../layouts/fade-in';
import ImageGallery from '../../../../../components/ImageGallery';
import SwipeableViews from 'react-swipeable-views';
import { useEffect, useRef, useState } from 'react';

export default function OneProduct__TextAndTagging(props) {
  const refText = useRef(null);
  const [widthText, setwidthText] = useState(0);
  useEffect(() => {
    if (refText.current) {
      setwidthText(refText.current.offsetWidth);
    }
  }, []);

  const [index, setIndex] = useState(0);

  const handleChangeIndex = (i) => {
    setIndex(i);
    // console.log(i);
  };

  // ImageGallery without thumbnails - should maintain 'open' state on the parent component
  const [open, setOpen] = useState(false);

  return (
    <Box sx={{ width: '58vw', paddingTop: 20 }}>
      <Typography
        className={props.fontStyle}
        ref={refText}
        sx={{
          display: 'block',
          color: '#ffffff44',
          width: 'fit-content',
          lineHeight: 1.2,
          fontSize: '11px !important',
          textAlign: 'center',
          marginBottom: 5,
        }}
      >
       The <span style={{ color: '#ffbf12' }}>buyer</span> gets a{' '}
          <span style={{ color: '#ffbf12' }}>shoutout</span><br/> with{' '}
          <span style={{ color: '#ffbf12' }}>just</span> their <span style={{ color: '#ffbf12' }}>handle</span>.<br/>
          <br />
          It's a <span style={{ color: '#ffbf12' }}>fixed templatE — text & tagging only</span><br/> with no option to add text or images, <br />
          and the <span style={{ color: '#ffbf12' }}>delivery is fully automated.</span><br/><br/> <span style={{ color: '#ffbf12' }}>Below, you can see examples of Shoutouts on the Shoutout Wall.</span>
           </Typography>
    
      <img
          src="/images/shoutout-wall-step3.png"
          alt="Shoutouts on the Shoutout Wall"
          style={{ width: '130px', display: 'block', margin: '0 auto' }}
          onClick={() => {
            setOpen(true);
          }}
        />

        <ImageGallery
          images={[
            "/images/shoutout-wall-step3.png",
          ]
          }
          index={index}
          open={open}
          setOpen={setOpen}
        />
      
      {/* </div>{' '} */}
    </Box>
  );
}
